import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../auth/services/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SharedModule } from '../../../../shared/shared.module';

import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-profile',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, SharedModule],
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
    user: any;
    passwordForm: FormGroup;
    isLoading = false;
    hideCurrent = true;
    hideNew = true;
    hideConfirm = true;

    constructor(
        private auth: AuthService,
        private fb: FormBuilder,
        private snack: MatSnackBar,
        public dialogRef: MatDialogRef<ProfileComponent>
    ) {
        this.passwordForm = this.fb.group({
            currentPassword: ['', Validators.required],
            newPassword: ['', [Validators.required, Validators.minLength(6)]],
            confirmPassword: ['', Validators.required]
        }, { validators: this.passwordMatchValidator });
    }

    ngOnInit(): void {
        this.user = this.auth.getUserData();
    }

    passwordMatchValidator(g: FormGroup) {
        return g.get('newPassword')?.value === g.get('confirmPassword')?.value ? null : { mismatch: true };
    }

    onSubmit() {
        if (this.passwordForm.invalid) return;

        this.isLoading = true;
        const { currentPassword, newPassword } = this.passwordForm.value;

        this.auth.changeMyPassword({ currentPassword, newPassword }).subscribe({
            next: (res) => {
                this.snack.open('Contraseña actualizada correctamente', 'Cerrar', {
                    duration: 3000,
                    horizontalPosition: 'end',
                    verticalPosition: 'bottom',
                    panelClass: ['bg-success', 'text-white']
                });
                this.passwordForm.reset();
                this.isLoading = false;
            },
            error: (err: any) => {
                this.snack.open(err.error?.msg || 'Error al cambiar contraseña', 'Cerrar', {
                    duration: 3000,
                    horizontalPosition: 'end',
                    verticalPosition: 'bottom',
                    panelClass: ['bg-danger', 'text-white']
                });
                this.isLoading = false;
            }
        });
    }
}
